import React, { Component } from "react";
import i18n from "../../i18n";
import { Translation } from "react-i18next";
import "../../assets/css/help.scoped.css";
import NavBar from "../NavBar";
import FooterSmall from "../FooterSmall";

const SupportGoogleForm = "https://docs.google.com/forms/d/e/1FAIpQLScxZpR8Vz892hOZ_1R1HaO82LAp24sdcEWgoUzjYfO74DTfPQ/viewform?usp=header";

export class SupportForm extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <>
      <NavBar />
      <div className="support-form-embed-wrapper" style={{ 
          //maxHeight: '80vh',
          overflowY: 'auto'
       }}>
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <iframe
            src={SupportGoogleForm}
            width="100%" 
            height="1285" 
            frameborder="0"
             margin="0 auto" 
             marginHeight="0"
             marginWidth="0"
             >
            Loading…</iframe>
        </div>
      </div>
        <div 
        style={{
          position: 'relative',
        }}
        >
        <FooterSmall />
        </div>
      </>
    )
  }
}

